import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { EuiPickerComponent } from './eui-picker.component';
import { EuiModalPickerComponent } from './modal-picker/eui-modal-picker.component';
import { EuiDialogService } from '../eui-dialog';
import { DYNAMIC_COMPONENT_CONFIG } from '../../services/eui-dynamic-component.service';
import { EuiChipModule } from '../eui-chip';
import { EuiChipListModule } from '../eui-chip-list';
import { EuiBadgeModule, EuiLabelModule } from '../atoms';

@NgModule({
    imports: [
        CommonModule,
        EuiBadgeModule,
        EuiLabelModule,
        EuiChipListModule,
        EuiChipModule,
        ReactiveFormsModule,
    ],
    declarations: [
        EuiPickerComponent,
        EuiModalPickerComponent,
    ],
    exports: [
        EuiPickerComponent,
    ],
    providers: [
        EuiDialogService,
        {
            provide: DYNAMIC_COMPONENT_CONFIG,
            useClass: EuiDialogService,
        }
    ],
    entryComponents: [
        EuiModalPickerComponent,
    ]
})
export class EuiPickerModule { }
